import React from "react";

const flags = {
  tr: (
    <svg viewBox="0 0 24 16" aria-hidden className="fx-flag-svg">
      <rect width="24" height="16" rx="2" fill="#e30a17" />
      <circle cx="9.2" cy="8" r="4.2" fill="#fff" />
      <circle cx="10.1" cy="8" r="3.35" fill="#e30a17" />
      <polygon
        fill="#fff"
        points="13.8,8 15.6,8.65 14.55,7.05 14.55,8.95 15.6,7.35"
      />
    </svg>
  ),
  en: (
    <svg viewBox="0 0 24 16" aria-hidden className="fx-flag-svg">
      <rect width="24" height="16" rx="2" fill="#012169" />
      <path d="M0 0 L24 16 M24 0 L0 16" stroke="#fff" strokeWidth="2.6" />
      <path d="M0 0 L24 16 M24 0 L0 16" stroke="#c8102e" strokeWidth="1.4" />
      <path d="M12 0 V16 M0 8 H24" stroke="#fff" strokeWidth="4.2" />
      <path d="M12 0 V16 M0 8 H24" stroke="#c8102e" strokeWidth="2.4" />
    </svg>
  ),
};

const LangFlag = ({ code }) => flags[code] || null;

export default LangFlag;
